const RATE = 200; // 200 points = £1

const getPointsValue = (points: number) => {
  const cost = points / RATE;
  return Number.isNaN(cost) || !Number.isFinite(cost) ? 0 : cost;
};

// Inverse of getPointsValue: convert a monetary value (£) back into points.
const getPointsFromValue = (value: number) => {
  const points = value * RATE;
  return Number.isNaN(points) || !Number.isFinite(points) ? 0 : points;
};

export default getPointsValue;
export { getPointsValue, getPointsFromValue };
